"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  NavigationMenu1: ['navigation-menu-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 0.753 L23.250 0.753 L23.250 5.253 L0.750 5.253 Z', 'M0.750 9.753 L23.250 9.753 L23.250 14.253 L0.750 14.253 Z', 'M0.750 18.753 L23.250 18.753 L23.250 23.253 L0.750 23.253 Z']],
  NavigationMenuHorizontal1: ['navigation-menu-horizontal-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-miterlimit': '10',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-miterlimit': '10',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-miterlimit': '10',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M6,10.5A1.5,1.5,0,1,0,7.5,12,1.5,1.5,0,0,0,6,10.5Z', 'M18,10.5A1.5,1.5,0,1,0,19.5,12,1.5,1.5,0,0,0,18,10.5Z', 'M12,10.5A1.5,1.5,0,1,0,13.5,12,1.5,1.5,0,0,0,12,10.5Z', 'M0.750 12.003 A11.250 11.250 0 1 0 23.250 12.003 A11.250 11.250 0 1 0 0.750 12.003 Z']],
  NavigationMenuVertical: ['navigation-menu-vertical', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9.362 20.628 A2.625 2.625 0 1 0 14.612 20.628 A2.625 2.625 0 1 0 9.362 20.628 Z', 'M9.362 3.378 A2.625 2.625 0 1 0 14.612 3.378 A2.625 2.625 0 1 0 9.362 3.378 Z', 'M9.362 12.003 A2.625 2.625 0 1 0 14.612 12.003 A2.625 2.625 0 1 0 9.362 12.003 Z']],
  NavigationMenuHorizontal: ['navigation-menu-horizontal', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 12.023 A2.625 2.625 0 1 0 6.000 12.023 A2.625 2.625 0 1 0 0.750 12.023 Z', 'M18.000 12.023 A2.625 2.625 0 1 0 23.250 12.023 A2.625 2.625 0 1 0 18.000 12.023 Z', 'M9.375 12.023 A2.625 2.625 0 1 0 14.625 12.023 A2.625 2.625 0 1 0 9.375 12.023 Z']],
  NavigationMenu3: ['navigation-menu-3', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 12.003 A11.250 11.250 0 1 0 23.250 12.003 A11.250 11.250 0 1 0 0.750 12.003 Z', 'M7.5 8.253L16.5 8.253', 'M7.5 12.003L16.5 12.003', 'M7.5 15.753L16.5 15.753']],
  NavigationMenu: ['navigation-menu', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M2.25 18.003L21.75 18.003', 'M2.25 12.003L21.75 12.003', 'M2.25 6.003L21.75 6.003']],
  NavigationMenu4: ['navigation-menu-4', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 0.753 L23.250 0.753 L23.250 23.253 L0.750 23.253 Z', 'M6.75 7.503L17.25 7.503', 'M6.75 12.003L17.25 12.003', 'M6.75 16.503L17.25 16.503']],
  NavigationMenu2: ['navigation-menu-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M6.750 0.753 L23.250 0.753 L23.250 5.253 L6.750 5.253 Z', 'M3.750 9.753 L20.250 9.753 L20.250 14.253 L3.750 14.253 Z', 'M0.750 18.753 L17.250 18.753 L17.250 23.253 L0.750 23.253 Z']],
  NavigationMenuHorizontal2: ['navigation-menu-horizontal-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-miterlimit': '10',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-miterlimit': '10',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-miterlimit': '10',
    'stroke-width': '1.5'
  }], ['M0.750 0.753 L23.250 0.753 L23.250 23.253 L0.750 23.253 Z', 'M6,10.5A1.5,1.5,0,1,0,7.5,12,1.5,1.5,0,0,0,6,10.5Z', 'M18,10.5A1.5,1.5,0,1,0,19.5,12,1.5,1.5,0,0,0,18,10.5Z', 'M12,10.5A1.5,1.5,0,1,0,13.5,12,1.5,1.5,0,0,0,12,10.5Z']]
};
exports["default"] = _default;